import styled from "styled-components";

export const BIAnnualReportContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
